import { render } from "./NButtonFileSelect.vue?vue&type=template&id=4ffc472a&ts=true"
import script from "./NButtonFileSelect.vue?vue&type=script&lang=ts"
export * from "./NButtonFileSelect.vue?vue&type=script&lang=ts"

import "./NButtonFileSelect.vue?vue&type=style&index=0&id=4ffc472a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__